const BACKEND_DEVICE = '/signing';

export const ROUTE_HOME_SIGNING = BACKEND_DEVICE + '/home';

export const signingRoutes = [ROUTE_HOME_SIGNING];
